var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.componentState,
      attrs: { "data-component": "base-item-info" },
    },
    [
      _vm.icon
        ? _c(
            "div",
            { staticClass: "icon-wrapper" },
            [_c("or-icon", { attrs: { icon: _vm.icon } })],
            1
          )
        : _vm.person
        ? _c(_vm.avatarType, {
            tag: "component",
            attrs: { person: _vm.person, avatar: _vm.avatar },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "title", attrs: { "data-title": "" } }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _vm.description
          ? _c("div", { staticClass: "description" }, [
              _vm._v("\n      " + _vm._s(_vm.description) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status
          ? _c(
              "div",
              {
                staticClass: "status",
                class: _vm.statusState,
                attrs: { "data-status": "" },
              },
              [_vm._v("\n      " + _vm._s(_vm.status) + "\n    ")]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }